<template lang="pug">
.RemainTextIndicator
  .icons
    .icon(
      v-for="i in 10"
      :class="{ done: currentPosition >= i }"
    )
      img(
        src="@/assets/scroll.svg"
      )
</template>

<script>
// import moment from 'moment'
// import soundService from '@/services/SoundService'

export default {
  name: 'km-remain-text-indicator',
  components: {},
  props: ['currentCount', 'maxCount'],
  data() {
    return {}
  },
  computed: {
    currentPosition: function() {
      return (this.currentCount / this.maxCount) * 10
    }
  },
  methods: {},
  mounted() {}
}
</script>

<style lang="scss" scoped>
.RemainTextIndicator {
  position: relative;

  .icons {
    display: flex;
  }

  .icon {
    margin: 0 10px 0 0;
    width: 20px;
    opacity: 0.5;
    transform: rotate(30deg);

    &.done {
      opacity: 1;
    }
  }
}
</style>
